import React, { useEffect, useRef, useState } from 'react';
import Label from 'components/Label';
import './styles.scss';
import ResidentialTab from './Products/Residential/Tab';
import ResidentialPricingCard from './Products/Residential/Card';
import ResidentialPlan from './Products/Residential/Plan';
import DatacenterPlan from './Products/Datacenter/Plan';
import DatacenterPricingCard from './Products/Datacenter/Card';
import DatacenterTab from './Products/Datacenter/Tab';
import { residential_marks } from './helpers';
import StaticPricingCard from './Products/Static/Card';
import StaticPlan from './Products/Static/Plan';
import StaticResidentialTab from './Products/Static/Tab';
import ProductTable from './ProductTable';
import { useSelector } from 'react-redux';
import { selectCurrentDatacenterProxies, selectCurrentResidentialProxies, selectCurrentStaticResidentialProxies, selectProductCalc } from 'store/slices/GeneralSlice';
import useMediaQuery from 'hooks/useMediaQuery';
import { useAnimation } from 'hooks/useAnimation';
import { useParams } from 'react-router-dom';
// import { fetchProductsData } from 'store/slices/PricingSlice';

const DATACENTER = 'datacenter';
const STATIC = 'static';
const RESIDENTAL = 'residental';

const ProductPrice = ({ isLoading, withTable = true }) => {
    const { productSlug } = useParams()
    const { tag, title } = useSelector(selectProductCalc)
    const [selectedTab, setSelectedTab] = useState();
    const [residentialValue, setResidentialValue] = useState(residential_marks[3]);
    const [datacenterValue, setDatacenterValue] = useState(100);
    const [staticValue, setStaticValue] = useState(100);
    const datacenterProxies = useSelector(selectCurrentDatacenterProxies)
    const staticResidentialProxies = useSelector(selectCurrentStaticResidentialProxies)
    const residentialProxies = useSelector(selectCurrentResidentialProxies)
    const isBigTablet = useMediaQuery('max-width: 1024px')
    const container = useRef()

    const titles = {
        [DATACENTER]: `${title} premium ${datacenterProxies?.name}`,
        [STATIC]: `${title} ${staticResidentialProxies?.name}`,
        [RESIDENTAL]: `${title} ${residentialProxies?.name}`,
    };

    useEffect(() => {
        switch (`${productSlug}`) {
            case "datacenter-proxies":
                // @ts-ignore
                setSelectedTab(DATACENTER);
                break;
            case "static-residential-proxies":
                // @ts-ignore
                setSelectedTab(STATIC);
                break;
            case "residential-proxy":
                // @ts-ignore
                setSelectedTab(RESIDENTAL);
                break;
            default:
                // @ts-ignore
                setSelectedTab(DATACENTER);
                break;
        }
    }, [productSlug]);



    const getTab = () => {
        switch (selectedTab) {
            case DATACENTER:
                return <DatacenterTab sliderValue={datacenterValue} onChange={setDatacenterValue} />;
            case STATIC:
                return <StaticResidentialTab sliderValue={staticValue} onChange={setStaticValue} />;
            case RESIDENTAL:
                return <ResidentialTab sliderValue={residentialValue} onChange={setResidentialValue} />;
            default:
                return null;
        }
    };

    const getCard = () => {
        switch (selectedTab) {
            case DATACENTER:
                return <DatacenterPricingCard sliderValue={datacenterValue} onChange={setDatacenterValue} />;
            case STATIC:
                return <StaticPricingCard sliderValue={staticValue} onChange={setStaticValue} />;
            case RESIDENTAL:
                return <ResidentialPricingCard sliderValue={residentialValue} onChange={setResidentialValue} />;
            default:
                return null;
        }
    };

    const getPlan = () => {
        switch (selectedTab) {
            case DATACENTER:
                return <DatacenterPlan />;
            case STATIC:
                return <StaticPlan />;
            case RESIDENTAL:
                return <ResidentialPlan />;
            default:
                return null;
        }
    };

    useAnimation({
        items: ['.product-price h2', '.product-price-container'],
        container,
        dependencies: [isLoading],
    })


    return (
        <section ref={container} className="container product-price">
            <Label text={tag} />
            <h2>{titles[selectedTab]}</h2>
            <div className="product-price-container">
                <div className="product-price-config">

                    <div className="product-price-tabs">
                        <div
                            className={`button-text product-price-tabs__item ${selectedTab === DATACENTER ? 'active' : ''
                                }`}
                            // @ts-ignore
                            onClick={() => setSelectedTab(DATACENTER)}
                        >
                            {datacenterProxies?.name}
                        </div>
                        <div
                            className={`button-text product-price-tabs__item ${selectedTab === STATIC ? 'active' : ''}`}
                            // @ts-ignore
                            onClick={() => setSelectedTab(STATIC)}
                        >
                            {staticResidentialProxies?.name}
                        </div>
                        <div
                            className={`button-text product-price-tabs__item ${selectedTab === RESIDENTAL ? 'active' : ''
                                }`}
                            // @ts-ignore
                            onClick={() => setSelectedTab(RESIDENTAL)}
                        >
                            {residentialProxies?.name}
                        </div>
                    </div>
                    {
                        !isBigTablet && <div className="product-price-range">{getTab()}</div>
                    }

                    {!isBigTablet && getPlan()}
                </div>
                {isBigTablet && getCard()}
                {isBigTablet && getPlan()}
                {!isBigTablet && getCard()}
            </div>
            {withTable && <ProductTable />}
        </section>
    );
};

export default ProductPrice;
